<mat-button-toggle-group [value]="value" (change)="handleChange($event)">
  @for (option of options; track optionTracker($index)) {
    <mat-button-toggle
      [value]="option.value"
      >
      {{ option.label }}
    </mat-button-toggle>
  }
</mat-button-toggle-group>
